export var AuxFacetedFilterOptionTypeEnum;
(function (AuxFacetedFilterOptionTypeEnum) {
    AuxFacetedFilterOptionTypeEnum["MultiSelect"] = "multi-select";
    AuxFacetedFilterOptionTypeEnum["DateRange"] = "date-range";
    AuxFacetedFilterOptionTypeEnum["PickList"] = "picklist";
    AuxFacetedFilterOptionTypeEnum["MultiSlider"] = "multi-slider";
})(AuxFacetedFilterOptionTypeEnum || (AuxFacetedFilterOptionTypeEnum = {}));
